/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export type BlastOption = {
   wmksService: any;
   key: string;
   isApp: boolean;
   isShadow: boolean;
   name: string;
   reconnectToken: string;
   triedSSLVerify: boolean;
   isMultiSession: boolean;
   enableUsb: boolean;
   usbTicket: string;
   redirectSetting?: ProtocolRedirectSettings;
   brokerUrl?: string;
   sessionId?: string;
   dspecId?: string;
   smartCardDummyService?: any;
   htmlCdrService?: any;
   isWindows365?: boolean;
   disableHeartBeat?: boolean;
   enableScannerRedirection?: boolean;
};

export enum PROTOCOL_RECOVERY_STATE {
   UNKNOWN,
   PENDING,
   DONE
}
